<template>
  <div class="container-fluid">
    <div class="row mb-12" v-if="false">
      <div class="col-lg-11 col-sm-12 notification-main">
        <div class="card h-100">
          <h3 class="card-header">
            <span class="text-caps">Оповещение</span>
          </h3>
          <div class="card-body">
            <div class="row">
              <div class="field-show col-lg-12 col-sm-12">В работе сервиса Vendoscope наблюдаются проблемы, связанные со связью модемов. Физическая перезагрузка модема не поможет.  В настоящий момент ведется работа по восстановлению связи. Просим прощения за доставленные неудобства в работе сервиса.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h1>Обзор <small class="text-muted">за последние 7 дней</small></h1>
    <div class="row mb-4">
      <div class="col-lg-4 col-sm-12">
        <div class="card h-100">
          <h3 class="card-header"><span class="text-caps">График продаж</span></h3>
          <div class="card-body d-flex align-items-center px-0">
            <graph
              class="w-100"
              endpoint="machines/sales"
              period="week_diff"
              :height="270"
              :data.sync="graphData"
            ></graph>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-sm-12">
        <div class="card h-100 d-flex">
          <h3 class="card-header flex-grow-0"><span class="text-caps">Продажи</span></h3>
          <div class="ml-3 flex-grow-1">
            <table class="table table-index-sales table-head-light w-100 table-sm px-0 mb-0" style="height: 250px;" v-if="sales">
              <thead>
              <tr>
                <th width="140">День недели</th>
                <th class="text-right" colspan="2">Количество</th>
                <th class="text-right pr-3" colspan="2">Сумма</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="sale in sales">
                <td style="text-transform: capitalize;">{{sale.dayOfWeek}}</td>
                <td class="text-right"><strong><number :number="sale.count "/></strong></td>
                <td class="text-right pl-0"><small><number-change :current="sale.count" :diff="sale.diff_count"/></small></td>
                <td class="text-right pl-4"><number :number="sale.sum "/></td>
                <td class="text-right pl-0 pr-3"><small><number-change :current="sale.sum" :diff="sale.diff_sum"/></small></td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="card-body flex-grow-0" v-if="$root.checkPermission('web_sales')">
            <router-link to="/reports/sales">Подробнее…</router-link>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-sm-12 d-flex flex-column">
        <div class="card">
          <h3 class="card-header"><span class="text-caps">На связи</span></h3>
          <div class="card-body">
            <div v-if="machinesStatus">
              <div class="d-flex align-items-center my-3 mx-2">
                <div class="text-large">{{Math.round((machinesStatus.online * 100) / machinesStatus.total)}} %</div>
                <div class="progress flex-grow-1 mx-3">
                  <div class="progress-bar" role="progressbar"
                    :style="'width:'+((machinesStatus.online*100) / machinesStatus.total)+ '%;'"
                    :aria-valuenow="machinesStatus.online" aria-valuemin="0"
                    :aria-valuemax="machinesStatus.total">
                  </div>
                  <!--<span class="mx-auto">{{ Math.round(100 - Math.round((machinesStatus.online * 100) / machinesStatus.total))}}%</span>-->
                </div>
                <div class="text-large"><strong>{{machinesStatus.online}}</strong> из {{machinesStatus.total}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4 flex-grow-1">
          <div class="col-md-6">
            <div class="card h-100">
              <h3 class="card-header"><span class="text-caps">Купюры</span></h3>
              <div v-if="stats" class="card-body d-flex flex-column justify-content-around">
                <div class="mb-2">Купюр в автоматах <br><strong class="text-large"><number :number="stats.banknotes.sum"/> руб.</strong></div>
                <div class="mb-2">Требуют инкассации <br><strong class="text-large"><number :number="stats.banknotes.count "/></strong></div>
                <router-link to="/reports/encashment" v-if="$root.checkPermission('web_collect')">Подробнее…</router-link>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card h-100">
              <h3 class="card-header"><span class="text-caps">Монеты</span></h3>
              <div v-if="stats" class="card-body d-flex flex-column justify-content-around">
                <div class="mb-2">Монет на сдачу <br><strong class="text-large"><number :number="stats.coins.sum "/> руб.</strong></div>
                <div class="mb-2">Требуют загрузки <br><strong class="text-large"><number :number="stats.coins.count "/></strong></div>
                <router-link to="/reports/encashment" v-if="$root.checkPermission('web_collect')">Подробнее…</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-lg-4 col-sm-12">
        <div class="card h-100 d-flex">
          <h3 class="card-header flex-grow-0"><span class="text-caps">Простои</span></h3>
          <div class="ml-3 flex-grow-1">
            <table class="table table-head-light w-100 h-100 table-sm px-0 mb-0" v-if="downtimes">
              <thead>
              <tr>
                <th>Организация</th>
                <th class="text-right">Суммарный простой</th>
                <th class="text-right pr-3">Автоматов с простоями</th>
              </tr>
              </thead>
              <tr v-for="downtime in downtimes" :class="{'text-muted': !(downtime.sum || downtime.count)}">
                <td>{{downtime.name}}</td>
                <td class="text-right">{{downtime.sum | formatDowntimesDuration}}</td>
                <td class="text-right pr-3"><number :number="downtime.count "/></td>
              </tr>
            </table>
          </div>
          <div class="card-body flex-grow-0" v-if="$root.checkPermission('web_downtime')">
            <router-link to="/reports/downtime">Подробнее…</router-link>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-sm-12">
        <div class="card h-100 d-flex">
          <h3 class="card-header flex-grow-0"><span class="text-caps">Несоблюдение плана обслуживания</span></h3>
          <div class="ml-3 flex-grow-1">
          <table class="table table-head-light w-100 h-100 table-sm px-0 mb-0" v-if="deviations">
              <thead>
              <tr>
                <th>Организация</th>
                <th class="text-right">Отклонений</th>
                <th class="text-right pr-3">Кол-во автоматов</th>
              </tr>
              </thead>
              <tr v-for="(deviation) in deviations" :class="{'text-muted': !(deviation.sum || deviation.count)}">
                <td>{{deviation.name}}</td>
                <td class="text-right"><number :number="deviation.sum "/></td>
                <td class="text-right pr-3"><number :number="deviation.count "/></td>
              </tr>
            </table>
          </div>
          <div class="card-body flex-grow-0" v-if="$root.checkPermission('web_service')">
            <router-link to="/service">Подробнее…</router-link>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-sm-12">
        <div class="card h-100 d-flex">
          <h3 class="card-header flex-grow-0"><span class="text-caps">Инкассации</span></h3>
          <div class="ml-3 flex-grow-1">
            <table style="table-layout: fixed;" class="table table-head-light w-100 h-100 table-sm px-0 mb-0" v-if="encashment">
              <thead>
              <tr>
                <th>Организация</th>
                <th class="text-right">Общая сумма</th>
                <th class="text-right pr-3">Несвоевременных</th>
              </tr>
              </thead>
              <tr v-for="index in encashment" :class="{'text-muted': !(index.sum || index.count)}">
                <td>{{index.name}}</td>
                <td class="text-right"><number :number="index.sum "/></td>
                <td class="text-right pr-3"><number :number="index.count "/></td>
              </tr>
            </table>
          </div>
          <div class="card-body flex-grow-0" v-if="$root.checkPermission('web_collect')">
            <router-link to="/reports/encashment">Подробнее…</router-link>
          </div>
        </div>
      </div>
    </div>

    <template v-if="showMachineBlock">
    <div class="row col-12 align-items-center ml-0 mr-0 pl-0 pr-0 mb-2">
      <h2>{{ machinesBlockTitle }}</h2>
      <span class="ml-auto">Фильтр</span>
      <button
        @click="filterMachinesBy('problematic')"
        :class="currentFilter === 'problematic' ? 'btn btn-primary btn-sm ml-2' : 'btn btn-outline-primary btn-sm ml-2'"
        :disabled="loadingMachines"
      >Проблемные</button>
      <button
        @click="filterMachinesBy('earning')"
        :class="currentFilter === 'earning' ? 'btn btn-primary btn-sm ml-2' : 'btn btn-outline-primary btn-sm ml-2'"
        :disabled="loadingMachines"
      >По доходу</button>
    </div>
    <div v-if="machines">
      <div class="card mb-5">
        <div class="card-header">
          <div class="row">
            <div class="col-md-5">
              <button
                type="button"
                class="btn btn-link p-0 text-body font-weight-bold"
                :aria-sort="machineSortAria('organization')"
                @click="sortMachineGroupsBy('organization')"
              >Организация {{ machineSortMark('organization') }}</button>
            </div>
            <div class="col-md-7">
              <button
                type="button"
                class="btn btn-link p-0 text-body font-weight-bold"
                :aria-sort="machineSortAria('count')"
                @click="sortMachineGroupsBy('count')"
              >Количество автоматов, требующих обслуживания {{ machineSortMark('count') }}</button>
            </div>
          </div>
        </div>
        <div id="machines-accordion" role="tablist" aria-multiselectable="true">
          <div v-for="(group, i) in machineGroups" :key="group.name" class="border-bottom">
            <a
              class="btn btn-lg btn-block text-body text-left"
              :class="Object.keys(machines).length === 1 ? '' : 'collapsed'"
              data-toggle="collapse"
              data-parent="#machines-accordion"
              :href="'#collapse'+i"
              aria-expanded="true"
              :aria-controls="`collapse${i}`"
              role="tab"
              :id="`heading${i}`"
            >
              <h5 class="mb-0">
                <div class="row">
                  <div class="col-md-5">{{group.name}}</div>
                  <div class="col-md-7">{{group.machines.length}}</div>
                </div>
              </h5>
            </a>
            <div
              :id="`collapse${i}`"
              class="collapse "
              :class="Object.keys(machines).length === 1 ? 'show' : ''"
              role="tabpanel"
              :aria-labelledby="`heading${i}`"
            >
              <table class="table mb-0">
                <thead>
                <tr>
                  <th width="100">
                    <button
                      type="button"
                      class="btn btn-link p-0 text-body font-weight-bold"
                      :aria-sort="machineRowSortAria('serial_number')"
                      @click="sortMachinesBy('serial_number')"
                    >№ автомата {{ machineRowSortMark('serial_number') }}</button>
                  </th>
                  <th width="180">Состояние</th>
                  <th width="130" class="text-right">
                    <button
                      type="button"
                      class="btn btn-link p-0 text-body font-weight-bold"
                      :aria-sort="machineRowSortAria('earnings_today')"
                      @click="sortMachinesBy('earnings_today')"
                    >Доход (сегодня) {{ machineRowSortMark('earnings_today') }}</button>
                  </th>
                  <th width="220">Посл. обслуживание</th>
                  <th>Место установки</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="machine in group.machines" :key="machine.id">
                  <td>
                    <router-link :to="`/machines/${machine.id}`" v-if="$root.checkPermission('web_ta_main')">
                      {{machine.serial_number}}
                    </router-link>
                    <div v-else>
                      {{machine.serial_number}}
                    </div>
                  </td>
                  <td><status-images :value="machine.status"></status-images></td>
                  <td align="right">{{machine.earnings_today == 0 ? '-' : machine.earnings_today + ' ₽'}}</td>
                  <td>{{machine.last_service_at | formatDate}}</td>
                  <td>{{machine.address}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    </template>
  </div>
</template>

<script>
  import tail from 'lodash/tail'
  import zip from 'lodash/zip'
  import moment from 'moment'
  import api from '@/api'

  export default {
    metaInfo: {title: 'Обзор'},
    data () {
      return {
        city: null,
        graphData: null,
        machines: null,
        currentFilter: null,
        loadingMachines: false,
        machineSort: {
          field: 'organization',
          direction: 'asc',
        },
        machineRowSort: {
          field: 'serial_number',
          direction: 'asc',
        },
      }
    },
    computed: {
      machinesStatus () {
        return this.dashboardSummary && this.dashboardSummary.status
      },
      encashment () {
        return this.dashboardSummary && this.dashboardSummary.encashment
      },
      downtimes () {
        return this.dashboardSummary && this.dashboardSummary.downtimes
      },
      deviations () {
        return this.dashboardSummary && this.dashboardSummary.deviations
      },
      stats () {
        return this.dashboardSummary && this.dashboardSummary.stats
      },
      showMachineBlock () {
        const region = this.$root.user && this.$root.user.region
        if (!region || region.money === null || region.money === undefined) return true

        return Number(region.money) >= 0
      },
      machinesBlockTitle () {
        if (this.currentFilter === 'problematic') return 'Автоматы, требующие обслуживания'
        if (this.currentFilter === 'earning') return 'Автоматы по доходу'
        return 'Автоматы'
      },
      machineGroups () {
        if (!this.machines) return []

        const direction = this.machineSort.direction === 'asc' ? 1 : -1
        const groups = Object.keys(this.machines).map((name) => {
          return {
            name,
            machines: this.sortMachines(this.machines[name]),
            earnings: this.machines[name].reduce((sum, machine) => {
              return sum + Number(machine.earnings_today || 0)
            }, 0),
          }
        })

        return groups.sort((left, right) => {
          if (this.machineSort.field === 'count') {
            const countDifference = left.machines.length - right.machines.length
            if (countDifference !== 0) return countDifference * direction
          }
          if (this.machineSort.field === 'earnings') {
            const earningsDifference = left.earnings - right.earnings
            if (earningsDifference !== 0) return earningsDifference * direction
          }

          const nameDirection = this.machineSort.field === 'organization' ? direction : 1
          return left.name.localeCompare(right.name, 'ru', {sensitivity: 'base'}) * nameDirection
        })
      },
      sales () {
        if (!this.graphData) return []
        return tail(zip(
          this.graphData.values,

          this.graphData.sales,
          this.graphData.revenue,
          this.graphData.before_sales,
          this.graphData.before_revenue,

          this.graphData.diff_sales,
          this.graphData.diff_costs,
          this.graphData.diff_before_sales,
          this.graphData.diff_before_cost,
        )).map((day) => ({
          dayOfWeek: moment(day[0]).format('dddd'),
          count: day[1] + day[3],
          sum: day[2] + day[4],
          diff_count: day[5] + day[7],
          diff_sum: day[6] + day[8],
        }))
      },
    },
    async created () {
      if (this.showMachineBlock) await this.fetchMachines()
    },
    methods: {
      async fetchMachines () {
        if (!this.showMachineBlock) return

        this.loadingMachines = true
        try {
          const { data } = await api.get(`index/machines`, {
            params: this.currentFilter ? {machineFilter: this.currentFilter} : {},
          })
          this.machines = data.data
        } catch (error) {
          console.error('Ошибка загрузки машин:', error)
        } finally {
          this.loadingMachines = false
        }
      },
      async filterMachinesBy (filterType) {
        if (this.currentFilter === filterType) return
        this.currentFilter = filterType
        if (filterType === 'earning') {
          this.machineSort = {field: 'earnings', direction: 'desc'}
          this.machineRowSort = {field: 'earnings_today', direction: 'desc'}
        } else {
          this.machineSort = {field: 'organization', direction: 'asc'}
          this.machineRowSort = {field: 'serial_number', direction: 'asc'}
        }
        await this.fetchMachines()
      },
      sortMachineGroupsBy (field) {
        if (this.machineSort.field === field) {
          this.machineSort.direction = this.machineSort.direction === 'asc' ? 'desc' : 'asc'
          return
        }

        this.machineSort.field = field
        this.machineSort.direction = 'asc'
      },
      machineSortMark (field) {
        if (this.machineSort.field !== field) return ''
        return this.machineSort.direction === 'asc' ? '↑' : '↓'
      },
      machineSortAria (field) {
        if (this.machineSort.field !== field) return 'none'
        return this.machineSort.direction === 'asc' ? 'ascending' : 'descending'
      },
      sortMachines (machines) {
        const direction = this.machineRowSort.direction === 'asc' ? 1 : -1

        return machines.slice().sort((left, right) => {
          if (this.machineRowSort.field === 'earnings_today') {
            const earningsDifference = Number(left.earnings_today || 0) - Number(right.earnings_today || 0)
            if (earningsDifference !== 0) return earningsDifference * direction
          }

          const serialDirection = this.machineRowSort.field === 'serial_number' ? direction : 1
          return String(left.serial_number || '').localeCompare(
            String(right.serial_number || ''),
            'ru',
            {numeric: true, sensitivity: 'base'}
          ) * serialDirection
        })
      },
      sortMachinesBy (field) {
        if (this.machineRowSort.field === field) {
          this.machineRowSort.direction = this.machineRowSort.direction === 'asc' ? 'desc' : 'asc'
          return
        }

        this.machineRowSort.field = field
        this.machineRowSort.direction = 'asc'
      },
      machineRowSortMark (field) {
        if (this.machineRowSort.field !== field) return ''
        return this.machineRowSort.direction === 'asc' ? '↑' : '↓'
      },
      machineRowSortAria (field) {
        if (this.machineRowSort.field !== field) return 'none'
        return this.machineRowSort.direction === 'asc' ? 'ascending' : 'descending'
      },
    },
    asyncComputed: {
      dashboardSummary: () => api.get(`index/summary`).then(({data}) => data.data),
    },
    filters: {
      formatDowntimesDuration (seconds) {
        if (!seconds) return seconds
        return Math.round(seconds / 60 / 60 / 24) + ' дн.'
      },
    },
  }
</script>

<style lang="scss">
  .table-index-sales {
    td, th {
      vertical-align: middle;
    }
  }
  .notification-main {
    margin: 10px auto 0;
    & .card {
      border-top: 2px solid #d21e1e;
    }
    & .text-caps {
      font-size: .9em;
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/index.vue